import React, { useState } from "react";
import { Input } from "@jammable/ui-components/Forms";
import { FaTimes } from "react-icons/fa";
import { SecondaryButton } from "@jammable/ui-core";
import { FaPlus } from "react-icons/fa6";

const CustomTagInput = ({ tags, setTags, className = "" }) => {
  const [inputValue, setInputValue] = useState("");

  const addTag = () => {
    const newTag = inputValue.trim().toLowerCase();
    if (!newTag || tags.includes(newTag) || tags.length >= 3) {
      setInputValue("");
      return;
    }

    setTags([...tags, newTag]);
    setInputValue("");
  };

  const removeTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div className={`tw-w-full ${className}`}>
      <div className="tw-text-sm tw-font-semibold tw-mb-3 tw-flex tw-items-center tw-mt-2">
        <label className="tw-text-sm tw-text-black/40 tw-uppercase tw-font-bold tw-mr-2">
          Tags
        </label>
        <span className="tw-bg-purple-100 tw-text-purple-700 tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-black">
          {tags.length}/3
        </span>
        <div className="tw-flex tw-items-center tw-gap-2 tw-ml-2 tw-flex-wrap">
          {tags.map((tag) => (
            <span
              onClick={() => removeTag(tag)}
              key={tag}
              className="tw-bg-purple-100 tw-cursor-pointer tw-text-purple-700 tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-black tw-flex tw-items-center tw-gap-1"
            >
              {tag}
              <FaTimes />
            </span>
          ))}
        </div>
      </div>

      {tags.length < 3 && (
        <div className="tw-relative tw-w-full">
          <Input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Add a tag..."
            className="tw-h-10 tw-w-full tw-pr-20"
            onKeyDown={handleKeyDown}
            maxLength={24}
          />
          <SecondaryButton
            type="button"
            onClick={addTag}
            disabled={!inputValue.trim()}
            className="tw-absolute tw-right-2 tw-top-1/2 tw--translate-y-1/2 tw-cursor-pointer tw-rounded-md tw-py-1 tw-px-3 tw-text-xs tw-transition-all tw-duration-200  disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-h-8 md:tw-px-4 tw-rounded-2xl"
          >
            <FaPlus />
            Add
          </SecondaryButton>
        </div>
      )}
    </div>
  );
};

export default CustomTagInput;
